<template lang="">
  <modal-padrao
    ref="modal-resumo-ordem-servico"
    max-width="80%"
    :titulo="titulo"
    :titulo-ok="$t('geral.botoes.imprimir')"
    :titulo-cancelar="$t('geral.botoes.voltar')"
    @ok="imprimir"
  >
    <div class="my-3">
      <span class="mr-2">
        <v-chip>{{ $t('modulos.operacao.resumo_os.tabela.ordem_servico') }}: {{ dadosOs?.codigo }}</v-chip>
      </span>
      <span>
        <v-chip>{{ $t('modulos.operacao.resumo_os.tabela.contratante') }}: {{ dadosOs?.participante?.nome }}</v-chip>
      </span>
    </div>
    <data-table
      :value="tabela.dados"
      show-gridlines
      class="p-datatable-sm tabela-prime-vue-inherit mb-4"
      :rows="10"
      data-key="codigo"
      :row-hover="true"
      filter-display="menu"
      responsive-layout="scroll"
      :expanded-rows.sync="expandedRows"
    >
      <Column
        expander
      >
        <template #body="{data}">
          <span v-if="data?.analiseTecnica?.length">
            <button @click="toggleRow(data)">
              <v-icon :class="{'rotated': expandedRows.find(i => i.codigo == data.codigo), 'not-rotated': !expandedRows.find(i => i.codigo == data.codigo), 'icon-margin': true}">
                $downArrow
              </v-icon>
            </button>
          </span>
        </template>
      </Column>
      <Column
        field="codigo"
        :header="$t('modulos.operacao.resumo_os.tabela.instrumento')"
      />
      <Column
        field="tipoInstrumento"
        :header="$t('modulos.operacao.resumo_os.tabela.tipo_instrumento')"
      />
      <Column
        field="marca"
        :header="$t('modulos.operacao.resumo_os.tabela.marca')"
      />
      <Column
        field="modeloInstrumento"
        :header="$t('modulos.operacao.resumo_os.tabela.modelo_instrumento')"
      />
      <Column
        field="numeroSerie"
        :header="$t('modulos.operacao.resumo_os.tabela.numero_serie')"
      />

      <template
        #expansion="{ data }"
      >
        <div
          class="orders-subtable"
          style="width: 100%; margin: 0rem"
        >
          <data-table
            striped-rows
            class="tabela-prime-vue-inherit"
            :value="data.analiseTecnica"
            edit-mode="row"
          >
            <template #header>
              <div v-if="data?.analiseTecnica?.length" />
            </template>
            <column
              v-for="(col, index) of colunasSelecionadas"
              :key="col.field + '_' + index"
              :field="col.field"
              :header="col.header"
              :styles="col.styles"
            >
              <template
                #body="slotProps"
              >
                <slot
                  v-if="col.field == 'codigo'"
                  :slotProps="slotProps"
                  :name="col.field"
                >
                  <icone-padrao
                    v-if="slotProps.data.tipoServicoPeca == 'Peca'"
                    :icone="'$cogOutline'"
                    :tooltip="'Peça'"
                  />
                  <icone-padrao
                    v-if="slotProps.data.tipoServicoPeca == 'Calibracao'"
                    :icone="'$wrenchClock'"
                    :tooltip="'Serviço de Calibração'"
                  />
                  <icone-padrao
                    v-if="slotProps.data.tipoServicoPeca == 'Manutencao'"
                    :icone="'$wrenchCog'"
                    :tooltip="'Serviço de Manutenção'"
                  />
                  <span style="margin-left: 5px;" />
                  {{ slotProps.data.codigo }}
                </slot>
                <slot
                  v-if="col.field == 'descricao'"
                  :slotProps="slotProps"
                  :name="col.field"
                >
                {{ slotProps.data.tipoServicoPeca }}
                </slot>
                <slot
                  v-if="col.field == 'tipoCalibracao'"
                  :slotProps="slotProps"
                  :name="col.field"
                >
                  {{ slotProps.data.tipoCalibracao }}
                </slot>
                <slot
                  v-if="col.field == 'tipoAprovacao'"
                  :slotProps="slotProps"
                  :name="col.field"
                >
                  {{ formatarTipoAprovacao(slotProps.data.tipoAprovacao) }}
                </slot>
                <slot
                  v-if="col.field == 'aprovado'"
                  :slotProps="slotProps"
                  :name="col.field"
                >
                  {{ formatarValorBoolean(slotProps.data.aprovado) }}
                </slot>
                <slot
                  v-if="col.field == 'executado'"
                  :slotProps="slotProps"
                  :name="col.field"
                >
                  {{ formatarValorBoolean(slotProps.data.executado) }}
                </slot>
              </template>
            </column>
          </data-table>
        </div>
      </template>
    </data-table>
    <modal-visualizacao-relatorio
      ref="modal-pdf"
      :titulo="$t('modulos.ordem_servico.titulos.resumo_ordem_servico')"
    />
  </modal-padrao>
</template>
<script>
import OrdemServicoService from '@/common/services/cadastros/OrdemServicoService.js';
import helpers from '@common/utils/helpers';
import { ModalVisualizacaoRelatorio } from '@components/misc';
export default {
  components: {
    ModalVisualizacaoRelatorio
  },
  props: {
    titulo: { type: String, default: '' },
  },
  data() {
    return {
      dadosOs: {},
      expandedRows: [],
      tabela: {
        selecionados: [],
        colunasSelecionadas: [],
        dados: [],
        colunas: [
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.instrumento'),
            sortable: true,
            value: 'instrumento.codigo',
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.tipo_instrumento'),
            sortable: true,
            value: 'tipoInstrumento.nome',
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.marca'),
            sortable: false,
            value: 'marca',
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.modelo_instrumento'),
            sortable: false,
            value: 'modeloInstrumento.nome',
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.numero_serie'),
            sortable: false,
            value: 'numeroSerie',
          },
        ],
      },
      tabelaInterna: {
        colunas: [
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.codigo'),
            sortable: true,
            value: 'codigo',
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.descricao'),
            sortable: true,
            value: 'descricao',
            styles: { 'text-align': 'center' },
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.tipo_calibracao'),
            sortable: true,
            value: 'tipoCalibracao',
            styles: { 'text-align': 'center' },
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.tipo_aprovacao'),
            sortable: true,
            value: 'tipoAprovacao',
            styles: { 'text-align': 'center' },
            formatter: v => helpers.TipoAprovacaoEnum.find(el => el.value == v)?.text ?? v
          },
          {
            text: this.$t('modulos.operacao.resumo_os.tabela.aprovado'),
            sortable: true,
            value: 'aprovado',
            styles: { 'text-align': 'center' },
          },
                 {
            text: this.$t('modulos.operacao.resumo_os.tabela.executado'),
            sortable: true,
            value: 'executado',
            styles: { 'text-align': 'center' },
          },
        ],
      },
      colunasSelecionadas: [],
      itensPorpagina: 10,
    };
  },
  watch: {
    'form.outroSetor'(valor) {
      if (valor) {
        this.form.proximoSetorId = valor;
      }
    },
  },
  mounted() {
    this.tabelaInterna.colunas?.forEach((coluna) => {
      coluna.field = coluna.value;
      coluna.header = coluna.text;
    });
    this.colunasSelecionadas = this.tabelaInterna.colunas;
  },
  methods: {
    async abrirModal(item) {
      console.log('11111',item)
      await this.buscar(item.id);
      this.dadosOs = item;
      await this.$refs['modal-resumo-ordem-servico'].abrirModal();
    },
    fecharModal() {
      this.$refs['modal-resumo-ordem-servico'].fecharModal();
    },
    buscar(id) {
      this.$store.dispatch('Layout/iniciarCarregamento');
      OrdemServicoService.buscarResumoOrdemServico(id)
        .then((res) => {
          this.tabela.dados = res.data
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.ordem_servico.erros.id_invalido'));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    formatarValorBoolean(v){
      return helpers.BoleanoEnum.find((el) => el.value === v)?.text;
    },
    formatarTipoAprovacao(v){
      return helpers.TipoAprovacaoEnum.find((el) => el.value === v)?.text;
    },
    toggleRow(rowData) {
      const index = this.expandedRows.findIndex(row => row.codigo === rowData.codigo);
      if (index === -1) {
        this.expandedRows.push(rowData)
      } else {
        this.expandedRows.splice(index, 1)
      }
    },
    imprimir: function () {
      this.$refs['modal-pdf'].abrirModal('resumo-os', [
        { simbolo: 'id', valor: this.dadosOs.id },
      ]);
    },
    buscarTextoEnumTipoAprovacao(v){
      return helpers.TipoAprovacaoEnum.find(el => el.value == v)?.text ?? v
    }
  },
};
</script>
<style lang="scss">
.rotated {
  transform: rotate(360deg);
  transition: transform 0.8s ease;
}

.not-rotated {
  transform: rotate(270deg);
  transition: transform 0.8s ease;
}
.tabela-prime-vue-inherit {
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 0.001rem 0.5rem !important;
}

.p-datatable-header {
  padding: 0rem !important;
}

.orders-subtable {
  padding: 0 0 0px 145px !important;
  .p-datatable-wrapper {
    table {
      thead {
        th {
          background-color: lighten(#35507b, 50%) !important;
          border-left: 4px solid lighten(#35507b, 50%) !important;
          border-right: 4px solid lighten(#35507b, 50%) !important;
        }
      }
      tbody {
        tr {
          td:first-child {
            border-left: 4px solid lighten(#35507b, 50%) !important;
          }
          td:last-child {
            border-right: 4px solid lighten(#35507b, 50%) !important;
          }
        }
        tr:last-child {
          td {
            border-bottom: 4px solid lighten(#35507b, 50%) !important;
          }
        }
      }
    }
  }
}

.text-bold {
  font-weight: bold;
}

.custom-width {
  /* width: 2em !important; */
  background-color: red;
}
</style>

